import { Component, Prop, Vue } from 'vue-property-decorator';
import CategoryModel from '../../../../../models/CategoryModel';
import DepartmentModel from '../../../../../models/DepartmentModel';
import EmailModel from '../../../../../models/EmailModel';
import NoteTaskSave from '../../../../../models/NoteTaskSave';
import SubjectModel from '../../../../../models/SubjectModel';
import NotesTasksService from '../../../../../services/NoteTaskService';
const Email = require('../../../../../components/email/email.vue.html');
const Grid = require('../../../../../components/grid/grid.vue.html');
const Attachments = require('../../../../../components/attachments/attachments.vue.html');

@Component({
    components: {
        Email,
        Grid,
        Attachments
    }
})
export default class NoteTask extends Vue {
    @Prop({ type: Boolean, required: true }) showMe!: false;
    @Prop({ type: Number, required: false, default: 0 }) noteID!: 0;
    @Prop() hearingDetails!: any;

    dueDateMenu: Boolean = false;
    IsTask: boolean = false;
    Company: any = {};
    createDate: string = '';
    createTime: string = '';
    departments: Array<any> = [];
    selectedDept: number | null = null;
    categories: Array<any> = [];
    selectedCategory: CategoryModel | null = null;
    subjects: Array<SubjectModel> = [];
    selectedSubject: SubjectModel | null = null;
    taskDepartments: Array<any> = [];
    selectedTaskDepartments: Array<any> = [];
    emailDialog: Boolean = false;
    emailObj: EmailModel = { subject: '', body: '', attachments: [], recipients: '', additionalRecipients: '', emailSignature: '',fromEmail: '', function: { title: 'Attach to Note', action: 'attachEmailToNote' } };
    tempArryOfFiles: Array<string | undefined> = [];
    emailReq: any = {};
    isEmail: boolean = false;
    includeEmailSignature: boolean = true;
    attachments: Array<any> = [];
    searchValue: string = '';
    colleagueResults: any = { selected: [], data: [] };
    emailNote: string = '';
    noteDesc: string = '';
    originalNote: string = '';
    editedItem: any = {};
    editedIndex: number = -1;
    defaultItem: any = { pkid: '', status: 'Note', dateLUP: '', userLUP: '', createddate: Date.now(), createdby: '', subject: '', category: '', note: '', assignto: '', duedate: '', datecompleted: '' };  //not sure we're using this correctly.
    pkNoteId: number = 0;
    escalateTask: boolean = false;
    taskDueDate: any = null;
    taskEscalationDays: number | null = null;
    noteDetailsResponse: any = {};

    public service = new NotesTasksService();

    get submitButtonText() {
        return this.isEmail ? 'Save & Send Email' : 'Save';
    }

    get defaultDueDate() {
        if (this.selectedCategory)
            this.taskDueDate = this.selectedCategory.defaultDueDateString;
        else
            this.taskDueDate = this.taskDueDate;

        return this.taskDueDate;
    }

    get defaultEscalationDays() {
        if (this.selectedCategory)
            this.taskEscalationDays = this.selectedCategory.defaultEscalationDays
        else
            this.taskEscalationDays = this.taskEscalationDays;

        return this.taskEscalationDays;
    }

    get temporarySubject() {

        let model: SubjectModel = new SubjectModel();

        if (this.selectedSubjectModel.id == 0 && this.selectedSubjectModel.description != '') {
            model.id = this.selectedSubjectModel.id;
            model.description = this.selectedSubjectModel.description;
            model.defaultNote = this.selectedSubjectModel.defaultNote;
            model.active = this.selectedSubjectModel.active;
        }
        else
            this.selectedSubject = null;

        return model;
    }

    get departmentModel() {
        let model: DepartmentModel = new DepartmentModel();

        if (this.selectedDept)
            model.id = this.selectedDept

        return model;
    }

    get selectedCategoryModel() {
        let model: CategoryModel = new CategoryModel();

        if (this.selectedCategory) {
            model = this.selectedCategory;
            if (model.defaultEscalationDays == null || model.defaultEscalationDays == undefined)
                model.defaultEscalationDays = 0;
        }

        return model;
    }

    get selectedSubjectModel() {
        let model: SubjectModel = new SubjectModel();

        if (this.selectedSubject) {
            model = this.selectedSubject;
        }

        return model;
    }

    get emailAttachments() {
        return this.attachments.filter((obj: any) => obj.attachmentType == 'email');
    }

    get newAttachments() {
        return this.attachments.filter((obj: any) => obj.fileLocation == 'unknown');
    }

    get formTitle() {
        let title = this.noteID === 0 ? 'New' : 'Edit';
        let type = this.IsTask ? 'Task' : 'Note';
        return title + ' ' + type;;
    }

    get noteDate() {
        if (this.noteID != 0) {
            return this.noteDetailsResponse.createDate;
        }
        else {
            var d = new Date();
            return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        }
    }

    get noteTime() {
        if (this.noteID != 0)
            return this.noteDetailsResponse.createTime;
        else {
            var d = new Date();
            return d.getHours() + ':' + d.getMinutes();
        }
    }

    get createUser() {
        return this.noteID != 0 ? this.noteDetailsResponse.createUserID : this.$store.state.user.userName;
    }

    get disabled() {
        return this.noteDetailsResponse.editFlag == 0;
    }

    get filteredResults() {
        let temp: any = { data: [] };

        if (this.colleagueResults.data) {
            for (var x = 0; x <= this.colleagueResults.data.length - 1; x++) {
                if (this.selectedTaskDepartments.length > 0)
                    for (var i = 0; i <= this.selectedTaskDepartments.length - 1; i++) {
                        if (this.colleagueResults.data[x].fkDepartment == this.selectedTaskDepartments[i])
                            temp.data.push(this.colleagueResults.data[x]);
                    }
                else
                    temp.data.push(this.colleagueResults.data[x]);

                if (this.colleagueResults.selected) {
                    for (var y = 0; y <= this.colleagueResults.selected.length - 1; y++) {
                        if (this.colleagueResults.data[x].userID == this.colleagueResults.selected[y])
                            temp.data.push(this.colleagueResults.data[x]);
                    }
                }
            }
        }

        return temp;
    }

    remove(item: any) {
        const index = this.colleagueResults.selected.indexOf(item.userID)
        if (index >= 0) this.colleagueResults.selected.splice(index, 1)
    }

    mounted() {
        Promise.all([this.service.GetActiveCMIUsers(), this.service.GetUserDepartments(this.$store.state.user.userName), this.service.GetDepartments()])
            .then((responses) => {

                if (responses) {
                    this.colleagueResults.data = responses[0].data;
                    Vue.set(this.colleagueResults, 'selected', []);

                    this.departments = responses[1].data;
                    this.taskDepartments = responses[2].data;

                    if (this.noteID != 0) {
                        this.getItemDetails().then((resp) => {
                            this.getUserCompany();
                        });
                    }
                    else
                        this.getUserCompany();
                }

                let existing = this.departments.find((obj: any) => obj.default == 1);
                if (existing.id != null && this.noteID == 0) {
                    this.selectedDept = existing.id;
                    let companyNumber: number = 1;
                    return this.service.GetNoteCategories(companyNumber, existing.id, this.$store.state.user.userName)
                        .then((response) => {
                            this.categories = response.categories;
                            //Promise.resolve();
                            //this.$store.dispatch("isLoading", false);
                        })
                        .catch(error => {
                            //this.$store.dispatch("isLoading", false);
                            let temp: number = 0;
                        });
                }

            });

        
    }

    getUserCompany() {
        let temp: number = 0;
        this.service.GetUserCompany(this.createUser)
            .then((resp) => {
                if (resp) {
                    this.Company = resp.data[0];
                    this.$store.dispatch("isLoading", false);
                }
            })
            .catch(error => {
                this.$store.dispatch("isLoading", false);
            });

    }

    viewFile(item: any) {
        if (item) {
            this.service.streamFiles('Document/GetFile', { path: item.fileLocation })
                .then((response) => {
                    this.$store.dispatch("isLoading", false);
                    if (response)
                        if (response.isSuccess === undefined || response.isSuccess) {
                            // It is necessary to create a new blob object with mime-type 
                            // explicitly set otherwise only Chrome works like it should
                            let newBlob = new Blob([response], { type: response.type });
                            //let newBlob = new Blob([response], { type: "application/pdf" });

                            // IE doesn't allow using a blob object directly as link href 
                            // instead it is necessary to use msSaveOrOpenBlob
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(newBlob);
                                return;
                            }

                            // For other browsers: 
                            // Create a link pointing to the ObjectURL containing the blob.
                            let data = window.URL.createObjectURL(newBlob);
                            let link = document.createElement('a');
                            link.href = data;
                            link.target = "_blank";
                            //link.download = "testing.pdf";    //this will force it to download automatically
                            link.click();
                            setTimeout(() => {
                                // For Firefox it is necessary to delay revoking the ObjectURL
                                window.URL.revokeObjectURL(data);
                            }, 100);


                        }
                        else {
                            this.$store.dispatch("isLoading", false);
                            this.$store.dispatch('addApplicationMessages', { class: 'error', messages: [response.responseData] });
                        }
                });

        }
        else {
            //alert user that there was no file data found to view
        }
    }

    getItemDetails(): Promise<any> {
        return this.service.GetNoteDetailsByPkNoteID({ pkNote: this.noteID })
            .then((response) => {
                if (response) {

                    this.noteDetailsResponse = response;

                    this.mapExistingAttachments(response.noteAttachments);
                    this.pkNoteId = this.noteID;
                    this.noteDesc = response.note;
                    let existing = this.departments.find((obj: any) => obj.id == response.fkDepartment);
                    if (!existing) {
                        this.departments.push({ id: response.fkDepartment, description: response.departmentDescription });
                        console.log('selected department not part of user department list... adding to list');
                    }

                    //reload note categories with the selected department
                    this.selectedDept = response.fkDepartment;
                    let temp: number = 0;
                    if (this.selectedDept) {
                        temp = this.selectedDept;
                    }
                 
                    this.service.GetNoteCategories(response.fkCompany, response.fkDepartment, this.$store.state.user.userName)
                        .then((response) => {
                            this.categories = response.categories;

                            ////if the user had previously entered manual text, maintain it
                            //if (this.temporarySubject.id == 0)
                            //    this.subjects.push({ id: this.temporarySubject.id, active: this.temporarySubject.active, defaultNote: this.temporarySubject.defaultNote, description: this.temporarySubject.description });

                            existing = this.categories.find((obj: any) => obj.id == this.noteDetailsResponse.fkCategory);
                            if (!existing && this.noteDetailsResponse.category != '') {
                                console.log('selected category ' + this.noteDetailsResponse.fkCategory + ': ' + this.noteDetailsResponse.category + ' not part of user category list... adding to list');
                                let catObj = { id: this.noteDetailsResponse.fkCategory, description: this.noteDetailsResponse.category, defaultDueDate: '', defaultDueDateString: '', defaultEscalationDays: 0, assignTo: '' };
                                this.categories.push(catObj);
                                this.selectedCategory = catObj;
                            }
                            else
                                this.selectedCategory = existing;

                            //update subject dropdown and selected value
                            this.service.GetNoteSubjects(this.Company.id, this.departmentModel.id, this.selectedCategoryModel.id)
                                .then((response) => {
                                    this.subjects = response.data;

                                    existing = this.subjects.find((obj: any) => obj.id == this.noteDetailsResponse.fkSubject);
                                    if (!existing && this.noteDetailsResponse.subject != '') {
                                        console.log('selected subject not part of user subject list... adding to list');
                                        let tempSubject: SubjectModel = { id: this.noteDetailsResponse.fkSubject, description: this.noteDetailsResponse.subject, active: 1, defaultNote: '' };
                                        this.subjects.push(tempSubject);
                                        this.selectedSubject = tempSubject;
                                    }
                                    else
                                        this.selectedSubject = existing;

                                    ////if the user had previously entered manual text, maintain it
                                    //if (this.temporarySubject.id == 0)
                                    //    this.subjects.push({ id: this.temporarySubject.id, active: this.temporarySubject.active, defaultNote: this.temporarySubject.defaultNote, description: this.temporarySubject.description });

                                    this.$store.dispatch("isLoading", false);
                                })

                            this.$store.dispatch("isLoading", false);
                        })
                        .catch(error => {
                            this.$store.dispatch("isLoading", false);
                        });


                    this.IsTask = response.isTask;
                    this.escalateTask = this.taskEscalationDays != null || (this.taskEscalationDays != null && this.taskEscalationDays > 0);
                    if (this.IsTask) {
                        if (this.colleagueResults) {
                            this.colleagueResults.selected = response.assignTo;
                        }

                        this.taskDueDate = response.dueDateString;
                        this.taskEscalationDays = response.escalationDays;

                        this.escalateTask = this.taskEscalationDays != null || (this.taskEscalationDays != null && this.taskEscalationDays > 0);
                    }
                }
                this.$store.dispatch("isLoading", false);
            })
            .catch(error => {
                this.$store.dispatch("isLoading", false);
            });

    }

    mapExistingAttachments(files: any) {
        this.attachments = [];

        if (files && files.length > 0)
            for (var i = 0; i <= files.length - 1; i++) {
                this.attachments.push({ fileName: files[i].fileName, fileLocation: files[i].fullPath });
            }

        this.$store.dispatch("isLoading", false);
    }

    deptChanged(): Promise<any> {
        this.selectedCategory = null;
        this.subjects = [];
        this.categories = [];

        return this.service.GetNoteCategories(this.Company.id, this.departmentModel.id, this.$store.state.user.userName)
            .then((response) => {
                this.categories = response.categories;

                ////if the user had previously entered manual text, maintain it
                //if (this.temporarySubject.id == 0 && (this.temporarySubject.description != '' || this.temporarySubject.description != null || this.temporarySubject.description != undefined))
                //    this.subjects.push({ id: this.temporarySubject.id, active: this.temporarySubject.active, defaultNote: this.temporarySubject.defaultNote, description: this.temporarySubject.description });

                Promise.resolve();

                this.$store.dispatch("isLoading", false);
            });
    }

    categoryChanged(): Promise<any> {
        this.subjects = [];

        if (this.colleagueResults) {
            this.colleagueResults.selected = this.selectedCategoryModel.assignTo;
        }

        this.taskDueDate = this.selectedCategoryModel.defaultDueDateString;
        this.taskEscalationDays = this.selectedCategoryModel.defaultEscalationDays;

        this.escalateTask = this.taskEscalationDays != null || (this.taskEscalationDays != null && this.taskEscalationDays > 0);

        return this.service.GetNoteSubjects(this.Company.id, this.departmentModel.id, this.selectedCategoryModel.id)
            .then((response) => {
                this.subjects = response.data;

                this.$store.dispatch("isLoading", false);

                ////if the user had previously entered manual text, maintain it
                //if (this.temporarySubject.id == 0 && (this.temporarySubject.description != '' || this.temporarySubject.description != null || this.temporarySubject.description != undefined))
                //    this.subjects.push({ id: this.temporarySubject.id, active: this.temporarySubject.active, defaultNote: this.temporarySubject.defaultNote, description: this.temporarySubject.description });

                Promise.resolve();
            })
    }

    subjectChanged(item: any) {
        this.selectedSubject = new SubjectModel();
        if (item)
            this.selectedSubject = item;

        if (this.selectedSubject && this.selectedSubject.defaultNote)
            this.noteDesc = this.selectedSubject.defaultNote;
    }

    dueDateInput(event: any) {
        this.taskDueDate = event != '' ? event.target.value : event;

        //if (this.selectedCategory)
        //    this.selectedCategory.defaultDueDate = event != '' ? event.target.value : event;
    }

    createNoteSaveObj(): NoteTaskSave {
        let obj: NoteTaskSave = {
            pkNote: 0, fkParent: 0, fkParentLocation: 0, subject: '', fkCategory: 0, currentUserID: '', note: '',
            warningNote: 0, fkCompany: 0, fkDepartment: 0, hasAttachment: 0, hasWorkingOn: 0, privilege: 0, objectDataID: 0, fkHearing: 0,
            attachments: [], assignedColleagues: [], isTask: false, dueDate: '', escalationDays: 0
        };

        obj.fkParent = this.hearingDetails.fkParent;
        obj.fkParentLocation = this.hearingDetails.fkParentLocation;
        obj.subject = this.selectedSubjectModel.description;
        obj.fkCategory = this.selectedCategoryModel.id;
        obj.currentUserID = this.$store.state.user.userName;
        obj.note = this.noteDesc;
        obj.fkCompany = this.Company.id;
        obj.fkDepartment = this.departmentModel.id;
        obj.hasAttachment = this.attachments.length > 0 ? 1 : 0;
        obj.hasWorkingOn = this.IsTask ? this.colleagueResults.select ? 1 : 0 : 0;
        obj.fkHearing = this.hearingDetails.pkHearing;
        obj.pkNote = this.pkNoteId;
        obj.assignedColleagues = this.colleagueResults.selected;
        obj.isTask = this.IsTask;
        obj.dueDate = this.taskDueDate;
        obj.escalationDays = this.selectedCategoryModel.defaultEscalationDays;

        return obj;
    }

    submit() {
        this.$store.dispatch("isLoading", true);
        this.$validator.validate()
            .then((result) => {
                if (result) {
                    let obj = this.createNoteSaveObj();

                    ///ONLY SAVE ATTACHMENTS THAT ARE NEW. NEW ATTACHMENTS WON'T HAVE A VALID FILE LOCATION
                    ///PROCESS THE NOTE, EMAIL AND ALL ATTACHMENTS
                    if (this.newAttachments && this.newAttachments.length > 0) {
                        this.service.UploadFiles(this.newAttachments, this.$store.state.user.userName)
                            .then((response) => {
                                {
                                    if (response) {
                                        for (var i = 0; i <= response.length - 1; i++)
                                            obj.attachments.push(response[i].filePath);

                                        this.saveNote(obj);
                                        this.processEmail(response);
                                    }
                                };
                            })
                    }   //END IF ATTACHMENTS
                    else {
                        this.saveNote(obj)
                        this.processEmail();
                    }
                }
                else
                    this.$store.dispatch("isLoading", false);
            })
    }

    addManualEntry(item: any) {
        let newSubject = item.currentTarget._value;
        if (newSubject) {
            //todo: sc - update this b/c it's not looking up correctly
            const index = this.subjects.indexOf(newSubject);
            if (index == -1) {
                let newSubjectModel = { id: 0, defaultNote: null, description: newSubject, active: 1 }
                this.subjects.push(newSubjectModel);
                this.selectedSubject = newSubjectModel;
            }
        }
    }

    processEmail(response?: any | undefined) {
        if (this.isEmail) {
            this.emailReq = { subject: this.emailObj.subject, message: this.emailObj.body, recipients: this.emailObj.recipients, attachments: '', ccList: this.$store.getters.userEmail, fromEmail: this.$store.getters.userEmail  }

            //iterate through the responses (files) and see if they exist in the emailAttachments array
            //if they do, we need to add those file names to the attachments property on the emailReq object to be saved in the email table
            if (response) {
                for (var x = 0; x <= this.emailAttachments.length - 1; x++) {
                    let item: any = { fileName: '', filePath: '' };
                    item = response.find((obj: any) => obj.fileName == this.emailAttachments[x].fileName);

                    if (item)
                        this.tempArryOfFiles.push(item.filePath);
                }

                this.emailReq.attachments = this.tempArryOfFiles.join(';');
            }

            this.service.SendEmail(this.emailReq)
                .then((response) => {
                    if (response) {
                        this.$store.dispatch('addApplicationMessages', { class: 'success', messages: ["Email queued successfully!"] });
                    }
                    else {
                        this.$store.dispatch('addApplicationMessages', { class: 'error', messages: ["Something went wrong"] });
                    }
                    this.$store.dispatch("isLoading", false);
                    this.$emit('closed');
                })
                .catch(error => { })
        }
    }

    saveNote(req: NoteTaskSave): Promise<any> {
        return this.service.AddOrUpdateNote(req)
            .then((response) => {
                if (response) {
                    var msgs: any[] = [];
                    msgs.push('Note/Task saved successfully!');

                    this.$store.dispatch('addApplicationMessages', { class: 'success', messages: msgs })

                    this.$emit('closed');
                }
            })
            .catch(error => {
                this.$emit('closed');
                //add message with error information
            })

    }

    attachEmailToNote() {
        this.isEmail = this.emailObj.subject ? true : false;
        this.originalNote = this.noteDesc;
        this.emailNote = this.formatNoteContentFromEmail();
        this.noteDesc += this.emailNote;

        if (this.emailObj.attachments)
            for (var i = 0; i <= this.emailObj.attachments.length - 1; i++) {
                this.attachments.push(this.emailObj.attachments[i]);
            }

        this.removeEmailAttachments();
        this.emailDialog = false;
    }

    removeEmailAttachments() {
        //removes email type attachments from the array
        if (!this.isEmail)
            this.attachments = this.attachments.filter((obj: any) => (obj.attachmentType == 'note' || obj.attachmentType == undefined));
    }

    cancelEmail() {
        this.emailObj = { subject: '', body: '', attachments: [], recipients: '', additionalRecipients: '', emailSignature: '',fromEmail:'', function: { title: 'Attach to Note', action: 'attachEmailToNote' } }

        this.emailDialog = false;

        this.emailNote = '';
        this.noteDesc = this.originalNote;
        this.emailReq = {};
        this.isEmail = false;
        this.includeEmailSignature = true;
        this.removeEmailAttachments();
    }

    formatNoteContentFromEmail() {
        if (this.emailObj.subject) {
            this.includeEmailSignature = false;
            var test = '\n\nEmail Subject: ' + this.emailObj.subject;
            test += '\n\nEmail Recipients: ' + this.emailObj.recipients + this.emailObj.additionalRecipients;
            test += '\n\nEmail Body: ' + this.emailObj.body;
            return test;
        }
        else
            return '';
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetask.ts